import { Chip } from "@mui/material";
import { HStack } from "@zfp-akademie-a-s/zfp-design";
import { HomeIcon, ShieldIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { CoinsIcon, DebtIcon, FinancialSuccessIcon, HealthIcon, PiggyBankIcon, TargetIcon } from "Components/_Shared/Icons/Icons";
import { Tile } from "Components/_Shared/Tile";
import { AmountFrequency, type ExpenseLine, ExpenseLineExpenseType } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { type FC, useState } from "react";
import { EXPENSE_TYPE_TRANSLATION_KEY } from "../expenseTypes";
import { EditExpenseDrawer } from "./EditExpenseDrawer";

type Props = {
  expense: ExpenseLine;
};

const getIcon = (expenseType: ExpenseLineExpenseType) => {
  switch (expenseType) {
    case ExpenseLineExpenseType.housing:
      return <HomeIcon />;
    case ExpenseLineExpenseType.consumption:
      return <FinancialSuccessIcon />;
    case ExpenseLineExpenseType.life_style:
      return <HealthIcon />;
    case ExpenseLineExpenseType.loan:
      return <DebtIcon />;
    case ExpenseLineExpenseType["financial-product"]:
      return <PiggyBankIcon />;
    case ExpenseLineExpenseType.insurance:
      return <ShieldIcon />;
    case ExpenseLineExpenseType.other:
      return <TargetIcon />;
  }
};

export const ExpenseTile: FC<Props> = ({ expense }) => {
  const { t } = useResource();

  const [editDrawerOpen, setEditDrawerOpen] = useState(false);

  return (
    <>
      <Tile
        title={t(Resources.AnalysisDetail.Budget.Expenses.ExpenseTypes[EXPENSE_TYPE_TRANSLATION_KEY[expense.expenseType]])}
        icon={getIcon(expense.expenseType)}
        onClick={() => setEditDrawerOpen(true)}
      >
        <HStack alignItems="center" flexWrap="wrap" gap={Spacing.M}>
          <Chip size="small" icon={<CoinsIcon />} label={formatCurrency(expense.amount.value, expense.amount.currencyCode)} />
          <Chip
            size="small"
            label={
              <>
                {expense.amount.frequency === AmountFrequency.monthly && t(Resources.Common.Monthly)}
                {expense.amount.frequency === AmountFrequency.yearly && t(Resources.Common.Year)}
              </>
            }
          />
        </HStack>
      </Tile>

      <EditExpenseDrawer open={editDrawerOpen} onClose={() => setEditDrawerOpen(false)} expense={expense} />
    </>
  );
};
